export enum FormActionBtn {
  Delete = 1,
  Override,
  Reject,
  View,
  Retake,
  Print
}
